







































export default {
    props: ['certification'],
    data() {
        return {
            grade: {
                bmCerts: '建材认证',
                fireRating: '防火等级',
                certLogos: '产品认证',
                traceSourceCode: '区块链溯源码',
                standards: '相关标准',
            },
        };
    },
    methods: {
        blockChainToggle(row) {
            (this as any).$emit('blockChainToggle', row);
        },
        cellStyle({ rowIndex, columnIndex }) {
            const obj: any = { padding: '4px 0' };
            if (rowIndex === 4 && columnIndex === 0) {
                obj.verticalAlign = 'top';
            }
            return obj;
        },
    },
    computed: {
    },
};
